import { useRef, useState } from "react";
import { useSize, useUpdateEffect } from "ahooks";
import List from "../List";
import KeepScroll from "../../../lib/KeepScroll";
import useUrlState from "@ahooksjs/use-url-state";

export default (props) => {
  const [types, setTypes] = useState([
    {
      id: 1,
      name: "官方严选",
      keyword: "",
    },
    {
      id: 2,
      name: "超级捡漏",
      keyword: "",
    },
    {
      id: 4,
      name: "自由交易",
      keyword: "",
    },
    {
      id: 3,
      name: "开局号",
      keyword: "",
    },
  ]);

  const ref = useRef(null);
  const size = useSize(ref);
  const [tab, setTab] = useState(1);

  const [params, setParams] = useUrlState({}, { navigateMode: "replace" });
  useUpdateEffect(() => {
    setTypes(
      types.map((item) => {
        if (item.id === tab) {
          return { ...item, keyword: params.keyword };
        }
        return item;
      })
    );
  }, [params.keyword]);

  return (
    <div className="choose-account-content">
      <div
        className="choose-account-tab"
        style={{
          top: `calc(env(safe-area-inset-top) + ${props.size?.height || 45}px)`,
        }}
        ref={ref}
      >
        {types.map((item, index) => (
          <div
            key={index}
            className={`item ${item.id === tab ? "active" : ""}`}
            onClick={() => setTab(item.id)}
          >
            {item.name}
          </div>
        ))}
      </div>

      <div className="trade-body" style={{ paddingTop: size?.height || 50 }}>
        {types.map((item, index) => (
          <KeepScroll key={index} active={props.active && item.id === tab} lazy>
            <div
              className={`trade-body-item ${item.id === tab ? "active" : ""}`}
            >
              <List
                active={props.active && item.id === tab}
                type={item.id}
                keyword={item.keyword}
              />
            </div>
          </KeepScroll>
        ))}
      </div>
    </div>
  );
};
